// «Salute»: quello da cui dipende il lavoro dei pops, ognuno con un pallino e una riga.
import type { ReactNode } from 'react';
import type { ConnectedProvider, GitRegistry, UpdatesView } from '../../../lib/api';
import type { SseStatus } from '../../../lib/sse';
import { Widget } from '../Widget';

const LIVE: Record<SseStatus, { tone: string; text: string }> = {
  live: { tone: 'ok', text: 'collegata' },
  connecting: { tone: 'warn', text: 'mi collego…' },
  reconnecting: { tone: 'warn', text: 'mi ricollego…' },
  polling: { tone: 'warn', text: 'aggiornata ogni pochi secondi' },
  down: { tone: 'danger', text: 'scollegata' },
};

const TINT: Record<string, string> = { ok: 'mint', warn: 'sun', danger: 'coral' };

function Line({ tone, name, detail }: { tone: string; name: string; detail: ReactNode }) {
  return (
    <div className="dash-chip" data-tint={TINT[tone] ?? 'lilac'}>
      <span className="dash-chip-dot" aria-hidden />
      <span style={{ minWidth: 0 }}>
        <span className="dash-chip-name">{name}</span>
        <span className="dash-chip-detail trunc">{detail}</span>
      </span>
    </div>
  );
}

export function Health({
  sse,
  providers,
  git,
  updates,
}: {
  sse: SseStatus;
  providers: ConnectedProvider[] | null;
  git: GitRegistry[] | null;
  updates: UpdatesView | null;
}) {
  const failing = (git ?? []).filter((g) => g.lastTest && !g.lastTest.ok);
  return (
    <Widget
      title="Salute"
      icon="activity"
      detailsTo="/settings"
      detailsLabel="Impostazioni"
      tint="coral"
    >
      <div className="dash-chips">
        <Line tone={LIVE[sse].tone} name="Diretta" detail={LIVE[sse].text} />
        {providers && (
          <Line
            tone={providers.length ? 'ok' : 'danger'}
            name="Provider"
            detail={
              providers.length
                ? `${providers.length} collegati · ${providers.reduce((n, p) => n + p.models.length, 0)} modelli`
                : 'nessuno collegato'
            }
          />
        )}
        {git && (
          <Line
            tone={failing.length ? 'danger' : 'ok'}
            name="Git"
            detail={
              git.length === 0
                ? 'nessun server'
                : failing.length
                  ? `${failing[0].name}: ${failing[0].lastTest?.detail ?? 'prova fallita'}`
                  : `${git.length} server`
            }
          />
        )}
        {updates && (
          <Line
            tone={updates.updateAvailable ? 'warn' : 'ok'}
            name="Versione"
            detail={
              updates.updateAvailable
                ? `${updates.current} → ${updates.latest} disponibile`
                : `${updates.current}, aggiornata`
            }
          />
        )}
      </div>
    </Widget>
  );
}
